import Swiper from 'swiper/swiper-bundle';
class GrowthExecutiveSlider {
  constructor(el) {
    this.el = el;
    this.slides = [...this.el.querySelectorAll('.swiper-slide')];
    this.slidesCount = this.slides.length;
    this.nav = this.el.querySelector('.paging-arrow');
    this.nextEl = this.el.querySelector('.paging-arrow .next');
    this.prevEl = this.el.querySelector('.paging-arrow .prev');
    this.initEvents();
    this.onResize();
  }

  navVisibility() {
    this.nav.style.display = this.slides.length > this.visibleSlides ? 'flex' : 'none';
  }

  navHide() {
    this.removeNav();
    this.nav.style.display = 'none';
  }

  getIsMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  onResize() {
    this.isMobile = this.getIsMobile();
    this.visibleSlides = this.isMobile ? 1 : 2;
    this.resizeHandler();
  }

  initEvents() {
    this.onResize = this.onResize.bind(this);
    this.slideNext = this.slideNext.bind(this);
    this.slidePrev = this.slidePrev.bind(this);
    window.addEventListener('resize', this.onResize);
  }

  initSwiper() {
    this.slider = new Swiper(this.el, {
      slidesPerView: 1,
      spaceBetween: 5,
      loop: false,
      autoplay: false,
      watchOverflow: true,
      breakpoints: {
        768: {
          spaceBetween: 15,
          grid: {
            rows: 2,
            fill: 'row',
          },
        }
      },
      pagination: {
        el: this.el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    })
  }

  slideNext(e) {
    e.preventDefault();
    if(this.slider) {
      if (this.slider.isEnd) {
        this.slider.slideTo(0);
      } else {
        this.slider.slideNext();
      }
    }
  }

  slidePrev(e) {
    e.preventDefault();
    if(this.slider) {
      if(this.slider.isBeginning) {
        this.slider.slideTo(this.slider.slides.length - 1);
      } else {
        this.slider.slidePrev();
      }
    }
  }

  initNav() {
    if (this.nextEl && this.prevEl) {
      this.nextEl.addEventListener('click', this.slideNext);
      this.prevEl.addEventListener('click', this.slidePrev);
    }
  }

  removeNav() {
    if (this.nextEl && this.prevEl) {
      this.nextEl.removeEventListener('click', this.slideNext);
      this.prevEl.removeEventListener('click', this.slidePrev);
    }
  }

  resizeHandler() {
    if(this.slider) {
      if((this.slidesCount <= this.visibleSlides)) {
        this.slider.destroy();
        this.slider = null;
        this.navHide();
      }
    } else {
      if(this.slidesCount > this.visibleSlides) {
        this.initSwiper();
        this.initNav();
        this.navVisibility();
      } else {
        this.navHide();
      }
    }
  }

}

export default GrowthExecutiveSlider;